export const APP_NAME = "Pets · Perdidos e Achados";
export const APP_TAGLINE = "Reconectando corações e patas";
export const CONTACT_EMAIL = "perdidoseachadospets@gmail.com";
export const APPLE_STORE_URL =
  "https://apps.apple.com/br/app/pets-perdidos-e-achados/id6771606685";
export const GOOGLE_PLAY_URL =
  "https://play.google.com/store/apps/details?id=app.emergent.petreunion6e1d5ef9d&pcampaignid=web_share";
